var map = {
	"./angin_topan.png": 1411,
	"./angin_topan2.png": 9545,
	"./badai.png": 7628,
	"./badai2.png": 8484,
	"./badai_salju.png": 4454,
	"./badai_salju2.png": 6182,
	"./banjir.png": 5777,
	"./banjir2.png": 3079,
	"./biomedis.png": 4723,
	"./biomedis2.png": 5737,
	"./buatan_manusia.png": 8037,
	"./buatan_manusia2.png": 9731,
	"./gelombang_tinggi.png": 9494,
	"./gelombang_tinggi2.png": 9654,
	"./gempa_bumi.png": 3145,
	"./gempa_bumi2.png": 1215,
	"./gunung_api.png": 7372,
	"./gunung_api2.png": 1700,
	"./kebakaran.png": 7761,
	"./kebakaran2.png": 7863,
	"./kekeringan.png": 8132,
	"./kekeringan2.png": 940,
	"./kelautan.png": 2988,
	"./kelautan2.png": 4196,
	"./longsor_salju.png": 1387,
	"./longsor_salju2.png": 9953,
	"./perubahan-iklim.png": 652,
	"./perubahan-iklim2.png": 6852,
	"./puting_beliung.png": 3197,
	"./puting_beliung2.png": 9435,
	"./siklon_tropis.png": 8277,
	"./siklon_tropis2.png": 7619,
	"./suhu_ekstrim.png": 9828,
	"./suhu_ekstrim2.png": 5132,
	"./tanah_longsor.png": 5514,
	"./tanah_longsor2.png": 7906,
	"./tsunami.png": 4510,
	"./tsunami2.png": 2446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6491;